var map = {
	"./campus_icon.svg": "aYe2",
	"./cart.svg": "/jHn",
	"./close.svg": "loaY",
	"./close_eye.svg": "Tv3S",
	"./course-not-started.svg": "KIiF",
	"./course-time.svg": "cp00",
	"./course_nor.svg": "el4J",
	"./course_sel.svg": "sJR/",
	"./credentials.svg": "ddM0",
	"./doc.svg": "Qyyg",
	"./download.svg": "kLc4",
	"./gender.svg": "wrkm",
	"./grade.svg": "5wV2",
	"./home_style_grid.svg": "E+nN",
	"./home_style_normal.svg": "LAME",
	"./icon-exclamatory.svg": "n+BS",
	"./icon_change.svg": "HZlO",
	"./icon_down.svg": "YoDh",
	"./icon_fail.svg": "/xEw",
	"./icon_success.svg": "Xfkw",
	"./idNumber.svg": "rcWu",
	"./idcard.svg": "PI54",
	"./live-course.svg": "4el5",
	"./live.svg": "rPQe",
	"./my_nor.svg": "Q+tt",
	"./my_sel.svg": "mpJ0",
	"./name.svg": "k4Ug",
	"./navbar_close.svg": "c8j5",
	"./open_eye.svg": "cATe",
	"./report_age.svg": "PsOv",
	"./report_gender.svg": "r0om",
	"./report_name.svg": "9bWT",
	"./report_paint.svg": "Ujd5",
	"./report_phone.svg": "OTW2",
	"./report_school.svg": "yy91",
	"./require.svg": "Z7AR",
	"./school.svg": "CZml",
	"./select_triangle.svg": "OhPU",
	"./share.svg": "nMWn",
	"./stu_gender.svg": "acOZ",
	"./stu_grade.svg": "QLDD",
	"./stu_idcard.svg": "/5IV",
	"./stu_name.svg": "P6kI",
	"./stu_school.svg": "DEad",
	"./study_course_nor.svg": "VhFI",
	"./study_course_sel.svg": "7UqU",
	"./study_nor.svg": "EJr0",
	"./study_sel.svg": "k4GI",
	"./timetable.svg": "U/5E"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VZYf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg nonrecursive \.svg$
// module id = VZYf
// module chunks = 62